import { SwipeableDrawer } from "@mui/material"

import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

import * as Styled from "./BottomSheet.styled"

export const BottomSheet = (props) => {
    const {
        className,
        children,
        displayPuller,
        id,
        ModalProps,
        ...bottomSheetProps
    } = props

    return <Styled.SwipeableDrawer
        anchor="bottom"
        className={className}
        ModalProps={{
            ...ModalProps,
            keepMounted: true,
        }}
        pullerDisplayed={displayPuller}
        {...bottomSheetProps}
    >
        <Styled.Box id={id}>
            {displayPuller && <Styled.PullerContainer id="puller-container">
                <Styled.Puller />
            </Styled.PullerContainer>}
            {children}
        </Styled.Box>
    </Styled.SwipeableDrawer>
}

BottomSheet.propTypes = SwipeableDrawer.propTypes

BottomSheet.defaultProps = {
    displayPuller: false,
    id: "bottom-sheet",
    onOpen: undefinedFunctionWarning("onOpen"),
}